module.exports = __webpack_public_path__ + "img/header-cropped.ef75b33.svg";